/*
Author : Abaid ullah
Module: Visitor Types
github: https://github.com/abaid
*/

import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstanceV2 } from '../../Apis/AxiosV2';
import { VISITOR_TYPES_SERVICE } from '../EndPoints';

// create visitorTypes
export const CreateVisitorTypes = createAsyncThunk(
    'visitorTypes/createVisitorTypes',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post(VISITOR_TYPES_SERVICE.createVisitorTypes, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
// update visitorTypes
export const UpdateVisitorTypes = createAsyncThunk(
    'visitorTypes/updateVisitorTypes',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(VISITOR_TYPES_SERVICE.updateVisitorTypes, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);


// get visitorTypes by it id
export const GetVisitorTypeById = createAsyncThunk(
    'visitorTypes/getVisitorTypeById',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(`${VISITOR_TYPES_SERVICE.getVisitorTypeById}/${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
